// Рассчитывает количество SMS частей для текста
export const calcSmsParts20_70 = (text: string): number => {
  const len = Array.from(text).length;
  if (len === 0) return 0;
  if (len <= 20) return 1;
  return 1 + Math.ceil((len - 20) / 70);
};
